// Shop & Donations stay hidden on the public site until Stripe is connected; visible only in the Emergent preview.
export const STORE_VISIBLE = /preview\.emergentagent\.com$|^localhost$/.test(window.location.hostname);
